<template>
    <div :class="active ? 'block' : 'hidden'">
        <div class="fixed z-50 pin overflow-hidden bg-modal" @click.prevent="close"></div>
        <button @click.prevent="close" class="z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2">
            <span class="icon"><i class="mdi mdi-close"></i></span>
        </button>
        <div class="fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4">
            <div class="bg-white rounded shadow" @click.prevent="">
                <div class="flex items-top p-3 md:p-6 bg-white rounded-t">
                    <partner-avatar :external-url="partner.doctorAvatar" class="mr-2 w-10 h-10 md:w-12 md:h-12"></partner-avatar>
                    <div class="ml-4">
                        <div class="flex items-center">
                            <span class="icon mr-2 text-lg text-red-light"><i class="mdi mdi-map-marker"></i></span>
                            <span class="text-sm md:text-base">{{ partner.officeZipCode }} {{ partner.officeLocality }}</span>
                        </div>
                        <div class="flex items-center md:mt-1">
                            <span class="icon mr-2 text-lg text-blue-light"><i class="mdi mdi-account"></i></span>
                            <span class="text-sm md:text-base">{{ partner.doctorFirstName + ' ' + partner.doctorLastName }}</span>
                        </div>
                    </div>
                </div>
                <div class="uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 mb-4">{{ $t('Select_an_availability') }}</div>
                <div class="max-h-timeslots overflow-scroll">
                    <router-link
                        :to="{ name: 'partner-timeslot.show', query: {
                            doctorId: timeslot.doctorId,
                            dateTime: timeslot.dateTime,
                            medicalPractice: timeslot.medicalPractice,
                            latitude: timeslot.officeLatitude,
                            longitude: timeslot.officeLongitude,
                        } }"
                        v-for="timeslot in sortedTimeslots"
                        :key="timeslot.id"
                        class="block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker">
                        {{ timeslot.dateTime | momentFormatTimestamp($t('date_selector_format') + ' [' + $t('at') + '] ' + $t('time_format')) }}
                    </router-link>
                    <div class="py-1 rounded-b border-t"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'

import PartnerAvatar from '@/components/PartnerAvatar.vue'

export default {
    name: 'timeslot-selection-modal',

    props: ['active', 'partner'],

    mixins: [helpers],

    components: { PartnerAvatar },

    data () {
        return {
            selectedTimeslot: null
        }
    },

    computed: {
        sortedTimeslots () {
            return _.sortBy(this.partner.timeslots, ['dateTime'])
        }
    },

    methods: {
        close () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Patient/PartnerTimeslotSelectionModal.vue